import { Catalog, HolesaleRetailers, Home, Traders } from "./components";

export const MasterComponents = () => {
    return(
        <>
            <Home/>
            <Catalog/>
            <Traders/>
            <HolesaleRetailers/>
        </>
    )
};